import { ProtectedRouter } from 'infrastructure/routing';
import { Route, Routes } from 'react-router-dom';
import CreateBillingRequestLayout from './createupdate/Create/CreateBillingRequestLayout';
import UpdateBillingRequestLayout from './createupdate/Update/UpdateBillingRequestLayout';
import ApproveBillingLayout from './ApproveBilling/ApproveBillingLayout';
import UpdateInvoiceDatesLayout from './updateInvoiceDates/UpdateInvoiceDatesLayout';
import MigrateBillingRequestLayout from './migrate/MigrateBillingRequestLayout';
import UpdateMigratedBillingRequestLayout from './migrate/UpdateMigratedBillingRequestLayout';
import { BillingRouteContext } from './BillingRouteContext';
import { BILLING_SCHEDULE_READ_LIST } from 'domain/shared/newProject';

const BillingRouter = () => {
  return (
    <ProtectedRouter basePath="/billing">
      <Routes>
        <Route
          path=":billingScheduleId/:billingItemId/create"
          element={
            <BillingRouteContext permissionToCheck={[BILLING_SCHEDULE_READ_LIST]}>
              <CreateBillingRequestLayout />
            </BillingRouteContext>
          }
        />
        <Route
          path=":billingScheduleId/:billingRequestId/update"
          element={
            <BillingRouteContext permissionToCheck={[BILLING_SCHEDULE_READ_LIST]}>
              <UpdateBillingRequestLayout />
            </BillingRouteContext>
          }
        />
        <Route
          path=":billingScheduleId/:billingRequestId/approve"
          element={
            <BillingRouteContext permissionToCheck={[BILLING_SCHEDULE_READ_LIST]}>
              <ApproveBillingLayout />
            </BillingRouteContext>
          }
        />
        <Route
          path=":billingScheduleId/:billingRequestId/preview"
          element={
            <BillingRouteContext permissionToCheck={[BILLING_SCHEDULE_READ_LIST]}>
              <ApproveBillingLayout />
            </BillingRouteContext>
          }
        />
        <Route
          path=":billingScheduleId/invoice-dates/update"
          element={
            <BillingRouteContext permissionToCheck={[BILLING_SCHEDULE_READ_LIST]}>
              <UpdateInvoiceDatesLayout />
            </BillingRouteContext>
          }
        />
        <Route
          path=":billingScheduleId/:billingItemId/migrate"
          element={
            <BillingRouteContext permissionToCheck={[BILLING_SCHEDULE_READ_LIST]}>
              <MigrateBillingRequestLayout />
            </BillingRouteContext>
          }
        />
        <Route
          path=":billingScheduleId/:billingRequestId/update-migrated"
          element={
            <BillingRouteContext permissionToCheck={[BILLING_SCHEDULE_READ_LIST]}>
              <UpdateMigratedBillingRequestLayout />
            </BillingRouteContext>
          }
        />
      </Routes>
    </ProtectedRouter>
  );
};

BillingRouter.getRouterPath = () => '/billing/*';

export default BillingRouter;
